import request from '@/utils/request'

// 获取仪表盘数据
export function getDashboardData() {
  return request({
    url: '/statistics/dashboard',
    method: 'get'
  })
}

// 获取会员统计
export function getMemberStatistics(params) {
  return request({
    url: '/statistics/members',
    method: 'get',
    params
  })
}

// 获取课程统计
export function getCourseStatistics(params) {
  return request({
    url: '/statistics/courses',
    method: 'get',
    params
  })
}

// 获取教练统计
export function getTrainerStatistics(params) {
  return request({
    url: '/statistics/trainers',
    method: 'get',
    params
  })
}

// 获取财务统计
export function getFinanceStatistics(params) {
  return request({
    url: '/statistics/finance',
    method: 'get',
    params
  })
}

// 获取运营统计
export function getOperationStatistics(params) {
  return request({
    url: '/statistics/operations',
    method: 'get',
    params
  })
}

// 获取会员活跃度分布
export function getMemberActivityDistribution(period = 'month') {
  return request({
    url: '/statistics/members/activity',
    method: 'get',
    params: { period }
  })
}

// 获取会员增长趋势
export function getMemberGrowthTrend(period = 'month', count = 12) {
  return request({
    url: '/statistics/members/growth',
    method: 'get',
    params: { period, count }
  })
}

// 获取热门课程排行
export function getPopularCourses(limit = 10) {
  return request({
    url: '/statistics/courses/popular',
    method: 'get',
    params: { limit }
  })
}

// 获取预约趋势
export function getBookingTrend(period = 'day', count = 30) {
  return request({
    url: '/statistics/bookings/trend',
    method: 'get',
    params: { period, count }
  })
} 

// 教练当日预约
export function getCoachDailyBookings() {
  return request({
    url: '/statistics/bookings/coach-today',
    method: 'get'
  })
}

// 本周项目预约收入
export function getWeeklyProjectRevenue() {
  return request({
    url: '/statistics/bookings/projects-weekly',
    method: 'get'
  })
}

// 技师空档状态
export function getTechnicianAvailability() {
  return request({
    url: '/statistics/technicians/status',
    method: 'get'
  })
}

// 当日预约列表
export function getTodayBookings(limit = 20) {
  return request({
    url: '/statistics/bookings/today',
    method: 'get',
    params: { limit }
  })
}

// 最新会员注册
export function getLatestMembers(limit = 10) {
  return request({
    url: '/statistics/members/latest',
    method: 'get',
    params: { limit }
  })
}